import React from "react";
import GoodsTransfersOrdersGenericSkeleton from "./GoodsTransfersOrdersGenericSkeleton";

function GoodsTransfersOrdersDetailSkeleton() {
  return (
    <>
      <GoodsTransfersOrdersGenericSkeleton />
    </>
  );
}

export default GoodsTransfersOrdersDetailSkeleton;
